financialAidYear.classy.controller({
    name: 'FinancialAidYearController',
    inject: ['$scope', '$rootScope', 'authServiceFactory', 'SchoolModelService', 'DateService', 'HelpSystemModelService','ModelService', 'StandardCudFactory'],
    init: function() {
        this.$.SchoolModelService = this.SchoolModelService;
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.item = this.SchoolModelService.data[0];
        this.$rootScope.model = this.SchoolModelService;
        this.calculateMonth(this.$.item.Year_End);
        /*
        var curyear = new Date().getFullYear();
        this.$.year = new Array(curyear, curyear+1, curyear+2);
        */
        this.$.HelpSystemModelService = this.HelpSystemModelService;
        this.$.html = '<help-button active="active[0]" help-msg="HelpSystemModelService.get()[0].helpMsg[0]"></help-button>';
        this.$.html2 = '<help-button active="active[0]" help-msg="HelpSystemModelService.get()[0].helpMsg[0]"></help-button>';
        this.$.currentYear = this.DateService.getCurrentYear(this.$.item);  
    },
   submit: function(scope, instance, form)
    {
        var parent = this;
        if (form.$valid)
        {
            instance.options.factor  = .3;
            this.SchoolModelService.put(this.id, this.$.item, instance).then(function (response) {
                //parent.$.currentYear = parent.DateService.getCurrentYear(parent.$.item);
            });
        }
        else
        {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) 
    {
        this.SchoolModelService.set(this.SchoolModelService.data);
        if (typeof callback !== 'undefined')
            callback();
    },
    calculateMonth: function(month)
    {
        var months = {
            1: 'February', 2: 'March', 3: 'April', 4: 'May', 5: 'June', 6: 'July', 7: 'August',
            8: 'September', 9: 'October', 10: 'November', 11: 'December', 12: 'January'
        }
        //this.$.item.Year_End = Number(month);
        this.$.calcMonth = months[Number(month)]; 
    }
});
